import React from 'react';
import './BeforeStart.css';
import {
  MdOutlineStar,
  MdOutlineShoppingCart,
  MdCreditCard,
  MdCheckCircle,
  MdStore,
  MdOutlineInventory,
  MdWallet,
  MdLanguage,
  MdShoppingCart,
  MdOutlineVisibility,
  MdOutlineChevronRight,
  MdOutlineHome,
  MdOutlineShoppingBag,
  MdOutlineLocalOffer,
  MdOutlineHomeWork
} from 'react-icons/md';
import { FiEye, FiChevronRight } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const BeforeStart = () => {
  const handleDemoClick = () => {
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="beforestart-section">
      <div className="beforestart-container">
        {/* Header */}
        <div className="beforestart-header">
          <div className="beforestart-badge">
            <MdOutlineStar size={11} />
            <span>Demo Store</span>
          </div>
          <h2 className="beforestart-title">
            See the Store <span className="text-gradient-coral">Before You Start</span>
          </h2>
          <p className="beforestart-subtitle">
            Explore our demo store and see the full customer journey homepage to confirmation.
          </p>
        </div>

        {/* Steps */}
        <div className="steps-wrapper">
          <div className="steps-line"></div>
          <div className="steps-grid">
            {/* Step 1 */}
            <div className="step-item">
              <div className="step-icon-wrapper">
                <div className="step-icon">
                  <MdOutlineVisibility size={22} />
                </div>
                <span className="step-number">1</span>
              </div>
              <p className="step-title">Browse</p>
              <p className="step-desc">Customer lands</p>
              <FiChevronRight className="step-arrow" />
            </div>

            {/* Step 2 */}
            <div className="step-item">
              <div className="step-icon-wrapper">
                <div className="step-icon">
                  <MdOutlineShoppingCart size={22} />
                </div>
                <span className="step-number">2</span>
              </div>
              <p className="step-title">Add to Cart</p>
              <p className="step-desc">Picks variants</p>
              <FiChevronRight className="step-arrow" />
            </div>

            {/* Step 3 */}
            <div className="step-item">
              <div className="step-icon-wrapper">
                <div className="step-icon">
                  <MdWallet size={22} />
                </div>
                <span className="step-number">3</span>
              </div>
              <p className="step-title">Checkout</p>
              <p className="step-desc">COD / Online</p>
              <FiChevronRight className="step-arrow" />
            </div>

            {/* Step 4 */}
            <div className="step-item">
              <div className="step-icon-wrapper">
                <div className="step-icon">
                  <MdCheckCircle size={22} />
                </div>
                <span className="step-number">4</span>
              </div>
              <p className="step-title">Confirmed</p>
              <p className="step-desc">Order placed</p>
            </div>
          </div>
        </div>

        {/* Floating Labels */}
        <div className="floating-labels">
          <div className="floating-label floating-label-1">
            <MdOutlineHome size={11} />
            <span>Homepage</span>
          </div>
          <div className="floating-label floating-label-2">
            <MdOutlineInventory size={11} />
            <span>Product Page</span>
          </div>
          <div className="floating-label floating-label-3">
            <MdShoppingCart size={11} />
            <span>Cart</span>
          </div>
          <div className="floating-label floating-label-4">
            <MdCreditCard size={11} />
            <span>Checkout</span>
          </div>
        </div>

        {/* Demo Card */}
        <div className="demo-card-wrapper">
          <div className="demo-card-glow"></div>
          <div className="demo-card">
            <div className="demo-card-content">
              <div className="demo-grid">
                {/* Left Side - Demo Links */}
                <div className="demo-links">
                  <div className="demo-link-item">
                    <div className="demo-link-icon demo-link-apecific-1">
                      <MdStore size={18} />
                    </div>
                    <div className="demo-link-text">
                      <p className="demo-link-title">Homepage</p>
                      <p className="demo-link-desc">Preview &amp; interact</p>
                    </div>
                    <FiChevronRight size={16} className="demo-link-arrow" />
                  </div>

                  <div className="demo-link-item">
                    <div className="demo-link-icon demo-link-apecific-2">
                      <MdOutlineInventory size={18} />
                    </div>
                    <div className="demo-link-text">
                      <p className="demo-link-title">Product Page</p>
                      <p className="demo-link-desc">Preview &amp; interact</p>
                    </div>
                    <FiChevronRight size={16} className="demo-link-arrow" />
                  </div>

                  <div className="demo-link-item">
                    <div className="demo-link-icon demo-link-apecific-3">
                      <MdOutlineShoppingCart size={18} />
                    </div>
                    <div className="demo-link-text">
                      <p className="demo-link-title">Cart</p>
                      <p className="demo-link-desc">Preview &amp; interact</p>
                    </div>
                    <FiChevronRight size={16} className="demo-link-arrow" />
                  </div>

                  <div className="demo-link-item">
                    <div className="demo-link-icon demo-link-apecific-4">
                      <MdCreditCard size={18} />
                    </div>
                    <div className="demo-link-text">
                      <p className="demo-link-title">Checkout</p>
                      <p className="demo-link-desc">Preview &amp; interact</p>
                    </div>
                    <FiChevronRight size={16} className="demo-link-arrow" />
                  </div>

                  <button className="demo-btn" onClick={handleDemoClick}>
                    <FiEye size={18} />
                    View Demo Store
                  </button>
                </div>

                {/* Right Side - Demo Preview */}
                <div className="demo-preview">
                  <div className="preview-header">
                    <span className="preview-dot preview-dot-red"></span>
                    <span className="preview-dot preview-dot-yellow"></span>
                    <span className="preview-dot preview-dot-green"></span>
                    <div className="preview-url">
                      <MdLanguage size={10} />
                      <span>atelier-noor.com</span>
                    </div>
                  </div>
                  <div className="preview-content">
                    {/* Hero Banner */}
                    <div className="preview-hero">
                      <img
                        src="https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?auto=format&fit=crop&w=480&q=80"
                        alt="Hero banner"
                        className="preview-hero-img"
                      />
                      <div className="preview-hero-overlay"></div>
                      <div className="preview-hero-text">
                        <p className="preview-hero-label">Winter Edit</p>
                        <p className="preview-hero-title">Soft layers,<br />quiet luxury.</p>
                      </div>
                    </div>

                    {/* Product Grid */}
                    <div className="preview-products">
                      <div className="preview-product">
                        <img src="https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=480&q=80" alt="Product" />
                        <span className="product-badge">NEW</span>
                        <span className="product-price">PKR 4,890</span>
                      </div>
                      <div className="preview-product">
                        <img src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=480&q=80" alt="Product" />
                        <span className="product-badge hot">HOT</span>
                        <span className="product-price">PKR 3,250</span>
                      </div>
                      <div className="preview-product">
                        <img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=480&q=80" alt="Product" />
                        <span className="product-price">PKR 2,890</span>
                      </div>
                      <div className="preview-product">
                        <img src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=480&q=80" alt="Product" />
                        <span className="product-badge sale">SALE</span>
                        <span className="product-price">PKR 7,500</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="beforestart-footer">
          The same structure can be adapted for clothing, shoes, jewelry, cosmetics, food items, accessories, home products, and more.
        </p>
      </div>
    </section>
  );
};

export default BeforeStart;